export default __webpack_public_path__ + "static/media/title-masterDataIcon.929c3482.svg";